// useInspection.ts
import { useInspectionCached } from './useInspectionCached';

/**
 * Adapter over useInspectionCached, kept for its 8 legacy call sites (the old identity header,
 * the progress-indicator hooks, Review/Completed screens).
 *
 * This used to be an uncached useState(null) + useEffect loader: every mount re-read
 * the whole inspection from IndexedDB and rendered a null frame first, so the header
 * and every ToC indicator flashed empty/notStarted on each navigation - and a ToC
 * mount issued 3-4 duplicate concurrent reads (one per consumer hook). Sharing
 * useInspectionCached's query key means warm mounts render real data on the FIRST
 * frame, in-flight reads dedupe, and observation writes still propagate via
 * cacheInvalidationService's inspection-key invalidation.
 */
export function useInspection(externalId: string | undefined) {
  const { inspection, inspectionError, isLoadingInspection } =
    useInspectionCached(externalId);
  return { inspection, inspectionError, isLoadingInspection };
}
